import baseUrl from "../config/baseUrl";

const documentChart = async ({ token, userID, isAdmin }) => {
  try {
    const response = await fetch(
      `${baseUrl}/apireact/dashboard_get_processed_document_bar_chart_data?isAdmin=${isAdmin}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default documentChart;
